import { KnownDeliveryState } from '@groundfloor-platform/mgmt-service-g-sdk';
import { ValidDeliveryStatusChangeOption } from './open-locker-action.hook';
import { BookingFlowType } from '../../../../../ui/enums/booking-flow-type.enum';

export const openIntentMessage: { [key in KnownDeliveryState]: string } = {
  'in-progress': 'The locker is expecting a parcel',
  'retrieval-required': 'The locker contains a parcel',
  cancelled: 'The parcel was cancelled',
  collected: 'The parcel has already been collected',
  retrieved: 'The parcel has already been retrieved',
  delivered: 'The locker contains a parcel',
  'delivered-offline': 'The locker contains a parcel',
  overdue: 'The locker contains a parcel',
  abandoned: 'The locker has already been abandoned'
};

export const updateStatusOptions: { label: string; value: ValidDeliveryStatusChangeOption }[] = [
  { label: 'Collected - The customer has the delivery', value: 'collected' },
  { label: 'Cancelled - It was incorrectly/unsuccessfully delivered', value: 'cancelled' },
  { label: 'Retrieved - It has been taken back to the sender', value: 'retrieved' }
];

/**
 * Gets filtered status options based on booking flow type
 * @param bookingFlowType The resolved booking flow type
 * @returns Filtered status options array, excluding 'retrieved' for INVENTORY flow projects
 */
export function getUpdateStatusOptions(
  bookingFlowType: BookingFlowType
): { label: string; value: ValidDeliveryStatusChangeOption }[] {
  const isInventoryFlow = bookingFlowType === BookingFlowType.INVENTORY;

  if (isInventoryFlow) {
    return updateStatusOptions.filter((option) => option.value !== 'retrieved');
  }

  return updateStatusOptions;
}

export function getModalTitle(tag: 'OPEN_LOCKER'): string;
export function getModalTitle(tag: 'CHANGE_STATUS', currentStatus: KnownDeliveryState): string;
export function getModalTitle(tag: 'OPEN_LOCKER' | 'CHANGE_STATUS', currentStatus?: KnownDeliveryState): string {
  switch (tag) {
    case 'OPEN_LOCKER':
      return 'Open locker?';
    case 'CHANGE_STATUS':
      switch (currentStatus) {
        case KnownDeliveryState.Collected:
        case KnownDeliveryState.Cancelled:
        case KnownDeliveryState.Retrieved:
          return 'Success';
        default:
          return 'Also change the status?';
      }
    default:
      return '';
  }
}
